import {
  REPAYMENT_HOLIDAY_ASSERTION_SUBTEXT,
  REPAYMENT_HOLIDAY_ASSERTION_ACCORDIN_BULLETS_SUBTEXT,
} from "./Assertions.const";

export const RepaymentAssertionText = () => {
  return (
    <>
      <ul className="repayment-assertion-ul">
        <li>
          <span>
            A repayment holiday gives you a <b>6 month break</b> from your loan
            repayments
          </span>
          <ul>
            {REPAYMENT_HOLIDAY_ASSERTION_ACCORDIN_BULLETS_SUBTEXT.map(
              (item: string) => {
                return (
                  <li key={item}>
                    <span>{item}</span>
                  </li>
                );
              }
            )}
          </ul>
        </li>
      </ul>
      <ul>
        <li className="list-header">
          <span>Two types of repayment holidays are available</span>
          <ul>
            {REPAYMENT_HOLIDAY_ASSERTION_SUBTEXT.map((item: string) => {
              return (
                <li key={item}>
                  <span>{item}</span>
                </li>
              );
            })}
          </ul>
        </li>
      </ul>
    </>
  );
};

export const ExternTermAssertionText = () => {
  return (
    <>
      <ul>
        <li>
          <span>
            You can extend your Bounce Back loan so that your{" "}
            <b>final repayment is 10 years after you took out the loan</b>
          </span>
        </li>
        <li>
          <span>
            Extending the term of your loan will allow you to repay a smaller
            amount each month
          </span>
        </li>
        <li>
          <span>
            The total amount you owe will go up if you extend the term of your
            loan
          </span>
        </li>
      </ul>
    </>
  );
};
